import type { IconSvgObject } from './types';

const HdmiPortIcon: IconSvgObject = [
  ["path", { d: "M4 7H20C21.1046 7 22 7.89543 22 9V13C22 14.1046 21.1046 15 20 15H19.618C19.2393 15 18.893 15.214 18.7236 15.5528L18.5528 15.8944C18.214 16.572 17.5215 17 16.7639 17H7.23607C6.47852 17 5.786 16.572 5.44721 15.8944L5.27639 15.5528C5.107 15.214 4.76074 15 4.38197 15H4C2.89543 15 2 14.1046 2 13V9C2 7.89543 2.89543 7 4 7Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 11H17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default HdmiPortIcon;
